import { connect } from 'react-redux'
import actions from 'actions/dashboardTemplates'
import Component from 'components/DashboardViewer/Filter/DataSelection'

export default connect(null, { getDataSelections: actions.getDataSelections })(Component)
